import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "application-center flex-column-box" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "app-resource-container" }
const _hoisted_4 = { class: "app-center" }
const _hoisted_5 = { class: "app-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "app-icon" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "app-info" }
const _hoisted_10 = { class: "app-title" }
const _hoisted_11 = { class: "app-desc" }
const _hoisted_12 = { class: "resource-center" }
const _hoisted_13 = { class: "section-title-wrapper" }
const _hoisted_14 = { class: "resource-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "resource-item-left" }
const _hoisted_17 = { class: "resource-icon" }
const _hoisted_18 = { class: "resource-info" }
const _hoisted_19 = { class: "resource-title" }
const _hoisted_20 = { class: "resource-desc" }
const _hoisted_21 = { class: "resource-count" }
const _hoisted_22 = { class: "count-value" }
const _hoisted_23 = { class: "resource-overlay" }
const _hoisted_24 = { class: "resource-actions" }
const _hoisted_25 = ["onClick"]

import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserPackResource } from '@/views/serviceHall/taskCenter/useTaskCenter';

interface AppItem {
  path: string;
  title: string;
  description: string;
  icon: string;
}

// 应用中心数据

export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationCenter',
  setup(__props) {

const router = useRouter();
const { szrPackages, fetchUserResource } = useUserPackResource();

// 应用类型定义
const appList = ref<AppItem[]>([
  {
    path: 'video-translate',
    title: '视频多语言翻译',
    description: '视频内容翻译多种语言且实时字幕生成',
    icon: 'https://client-file.lzwcdm.com/static/image/%E8%A7%86%E9%A2%91%E5%A4%9A%E8%AF%AD%E8%A8%80%E7%BF%BB%E8%AF%91.png',
  },
  {
    path: 'pdf-to-video',
    title: 'PDF转视频',
    description: '将PDF文档智能转换为精美视频内容',
    icon: 'https://client-file.lzwcdm.com/static/image/PDF%E8%BD%AC%E8%A7%86%E9%A2%91.png',
  },
  {
    path: 'ai-plan-task',
    title: 'AI策划',
    description: '智能生成营销策划方案，提供创意灵感',
    icon: 'https://client-file.lzwcdm.com/static/image/AI%E7%AD%96%E5%88%92.png',
  },
  {
    path: 'copywriting-assistant',
    title: 'AI文案助手',
    description: '智能生成各类营销文案，提升内容质量',
    icon: 'https://client-file.lzwcdm.com/static/image/AI%E6%96%87%E6%A1%88%E5%8A%A9%E6%89%8B.png',
  },
]);

// 将应用列表分成每行两个应用的二维数组
const appRows = computed<AppItem[][]>(() => {
  const rows: AppItem[][] = [];
  for (let i = 0; i < appList.value.length; i += 2) {
    rows.push(appList.value.slice(i, i + 2));
  }
  return rows;
});

// 判断当前日期和商品序号的奇偶性是否匹配
const isMatchDayAndItem = (index: number) => {
  const currentDay = new Date().getDate();
  const isDayOdd = currentDay % 2 === 1; // 判断日期是否为单数
  const isIndexOdd = (index + 1) % 2 === 1; // 判断序号是否为单数
  return isDayOdd === isIndexOdd; // 日期和序号的奇偶性相同时返回true
};

// 添加敬请期待的数字人名片选项
const addSzrPackages = [
  // 可以根据需要添加额外的资源包
];

// 导航到应用
const navigateToApp = (appPath: string) => {
  router.push(`/${appPath}`);
};

// 导航到资源
const navigateToResource = (resourcePath: string) => {
  router.push(resourcePath);
};

onMounted(() => {
  fetchUserResource();
});

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-title" }, "应用中心", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appList.value, (app) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "app-item",
                key: app.path,
                onClick: ($event: any) => (navigateToApp(app.path)),
                style: _normalizeStyle({ '--app-bg-image': `url(${app.icon})` })
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: app.icon,
                    alt: app.title
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(app.title), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(app.description), 1)
                ])
              ], 12, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-title" }, "资源中心", -1)),
            _createElementVNode("a", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/service-hall-task-center`)))
            }, _cache[4] || (_cache[4] = [
              _createTextVNode("查看定制任务状态 "),
              _createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
            ]))
          ]),
          _createVNode(_component_el_scrollbar, {
            height: "345px",
            class: "resource-scrollbar"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(szrPackages), ...addSzrPackages], (resource, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "resource-item",
                    key: index,
                    onClick: ($event: any) => (navigateToResource(resource.path || `/service-hall-task-center?buyTpye=${resource.makeType}`))
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("i", {
                          class: _normalizeClass(resource.icon)
                        }, null, 2)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("h4", _hoisted_19, _toDisplayString(resource.label), 1),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(resource.tip), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(resource.usableCount), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "count-unit" }, "个", -1))
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        (!resource.usableCount)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-warning",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push('/membership-hub')), ["stop"]))
                            }, " 去开通 "))
                          : _createCommentVNode("", true),
                        (resource.usableCount)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-warning",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(router).push('/membership-hub')), ["stop"]))
                            }, " 去续量 "))
                          : _createCommentVNode("", true),
                        (resource.usableCount)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn-success",
                              onClick: _withModifiers(($event: any) => (_unref(router).push(resource.path || `/service-hall-task-center?buyTpye=${resource.makeType}`)), ["stop"])
                            }, _toDisplayString(resource.path ? '立即使用' : '去定制'), 9, _hoisted_25))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_15))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})